import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { IconButton } from '@mui/material';
import { getRef, handleSendMessage } from 'utils/Firebase.util';
import {
  arrayUnion,
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
} from 'firebase/firestore';
import { db } from 'app/firebase';
import { IAuthState } from 'interfaces/auth.interfaces';
import { useAppSelector } from 'app/hooks';
import { selectChat } from 'features/auth/chatSlice';
import { UserData } from 'interfaces/UserData.interface';

interface IChatOptions {
  children: React.ReactNode;
  authState: IAuthState;
  senderId: number;
  user?: UserData;
}

export default function ChatOptions({
  children,
  authState,
  senderId,
  user,
}: IChatOptions) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const chatState = useAppSelector(selectChat);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = async () => {
    if (!authState.id) return;
    try {
      const dbRef = await getRef(authState.id, senderId);
      if (dbRef) {
        const messages = await getDocs(
          query(collection(db, 'chats', dbRef, 'messages'))
        );
        messages.docs.forEach(async message => {
          if (message.data().id) {
            await updateDoc(
              doc(db, 'chats', `${dbRef}`, 'messages', message.data().id),
              {
                invisible: arrayUnion(authState.username),
              }
            );
          }
        });
      }
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  const handleInvite = async () => {
    if (user)
      await handleSendMessage(
        'Join as a creator now!',
        'invite',
        authState,
        user,
        chatState,
        chatState.currentIndex
      );
  };

  return (
    <div style={{ display: 'flex' }}>
      <IconButton onClick={handleClick}>{children}</IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={handleDelete}>Delete Chat</MenuItem>
        {authState.invites > 0 &&
          authState.isCreator &&
          user &&
          !user.isCreator && (
            <MenuItem onClick={handleInvite}>Invite Creator</MenuItem>
          )}
      </Menu>
    </div>
  );
}
